<template>
    <router-view></router-view>
</template>

<script lang="ts" src="./App.ts"></script>